/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { EventEmitter, Output, Directive, Input } from "@angular/core";
import { AbstractModalComponent } from "./abstract-modal.component";

@Directive()
export class AbstractModalComponentWithInputText extends AbstractModalComponent {
   public static readonly BUTTON_KEY = "buttonName";

   @Input()
   public inputTextData: string;

   public updateText(inputText: string) {
      this.inputTextData = inputText;
   }

   private getResult(buttonName: string) {
      return { BUTTON_KEY: buttonName, INPUT_TEXT: this.inputTextData };
   }

   @Output()
   public eventEntry: EventEmitter<any> = new EventEmitter();

   public confirmModalWithInputText = () => {
      this.eventEntry.emit(this.getResult(AbstractModalComponent.BTN_OK));
   };

   public cancelModalWithInputText = () => {
      this.eventEntry.emit(this.getResult(AbstractModalComponent.BTN_CANCEl));
   };
}
